<template>
	<div>

		<!-- <div>
			<table-filter :filters="filters" @onFilter="onFilterBackend" @onClear="clearFilters"></table-filter>
		</div> -->
		<FiltersTable titleButton="Obtener órdenes" searchPlaceholder="Buscar por 'Órden ML'" @onSearch="handleSearch"/>

		<div v-if="showDetailModal">
        <InvalidDetails :orderDetail="orderDetail" @orderDetail="handleOrderDetail" />
    </div>

		<VxTable 
			stripe 
			:data="orders" 
			pagination 
			:max-items="30"
			:total="totalItems"
			:sst="true" 
			@change-page="handleChangePage" >
			
			<template slot="thead">
				<vs-th>Órden ML</vs-th>
				<!-- <vs-th>Destinatario</vs-th> -->
				<vs-th>Comprador</vs-th>
				<vs-th>Valor</vs-th>
				<!-- <vs-th>Razón</vs-th> -->
				<vs-th>Fecha</vs-th>
				<vs-th>Actualizada</vs-th>
				<vs-th>Modo</vs-th>
				<vs-th>Acciones</vs-th>
			</template>

			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td>
						{{ data[indextr].id }} 
					</vs-td>
					<vs-td>
						Cuenta: <em>{{tr.buyer.first_name}} {{tr.buyer.last_name}} ({{tr.buyer.nickname}}).</em> <br>
						<template v-if="tr.shipment_data && tr.shipment_data.receiver_address">
							Recibe:  <em>{{tr.shipment_data.receiver_address.receiver_name}} </em>
						</template>
					</vs-td>
					<vs-td>
						$ {{tr.total_amount}}
					</vs-td>
					<!-- <vs-td>
						{{tr.reason_invalid}}
					</vs-td> -->
					<vs-td>
						{{ data[indextr].date_created | formatDate }}
					</vs-td>
					<vs-td>
						{{ data[indextr].last_updated | formatDateFromNow }}
					</vs-td>
					<vs-td>
						{{tr.shipment_data.mode | translateShipmentMode }}
					</vs-td>
					<vs-td>
						<!-- <vs-button type="border" size="small" color="primary" class="mr-2" 
							@click="openPopupDetalle(data[indextr])">
							<feather-icon icon="SearchIcon" svgClasses="h-2 w-2"/>
							Detalle
						</vs-button> -->
						<feather-icon @click="openDetails(tr)" icon="EyeIcon" svgClasses="h-5 w-5 mx-5 cursor-pointer" />
					</vs-td>
				</vs-tr>
			</template>

		</VxTable>

		<div v-if="showDetailModal">
        	<OrderDetails :orderDetail="orderDetail" @orderDetail="handleOrderDetails"/>
    	</div>

	</div>
</template>

<script>
// Extraer: 
// MOMENTJS and CONFIG
// AXIOS and CONFIG
// FILTERS 
import _ from 'lodash'// ya esta improtado en archivo local pero si no lo improto aca da errores aveces

import moment from 'moment'
moment.locale('es')

import axios from 'axios';
axios.defaults.withCredentials = true;

import OrderDetails from "../../components/modals/Orders/OrderDetails.vue";
import FiltersTable from "../../components/filters-table/FiltersTable.vue";

export default {
	components: {
		OrderDetails,
		FiltersTable
	},
	data(){
		return {
			orders: [],
			ordersPreserved:[], // used when reseting local filtering
			totalItems: 0,
			page: 1,
			selected: [], // Los items seleccionados con el checkbox 
			
			// Popup (detalle & proccesar)
			popupOrder: {}, // El item en que se ha clickeado Detalle o Procesar
			popupOrderShipmentInfo: null,
			// Popup - detalle
			popupDetalleActive: false,
			filtersSelected: [],

			showDetailModal: false,
      orderDetail: {},
		}
	},
	filters : {
		formatDate(rawDate){
			return moment(rawDate).format("D-M-Y");
		},
		formatDateFromNow(rawDate){
			return moment(rawDate).fromNow();
		},
		translateShipmentMode(mode){
			let modesMap = {
				'not_specified': 'Acuerdo con el vendedor',
				'custom': 'Envio Custom',
				'me1': 'Mercado Envíos 1',
				'me2': 'Mercado Envíos 2',
			}

			return modesMap[mode] ? modesMap[mode] : '';
		}
	},


	mounted() {
		this.loadOrders();	
	},

	methods: {

		loadOrders(page = 1) {
			this.$vs.loading();

			this.filtersSelected['page'] = page;

			try {
				const filtersSelected = this.filtersSelected;
				const query = Object.keys(filtersSelected)
				.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(filtersSelected[key]))
				.join('&');

				axios.get(process.env.VUE_APP_BACKEND_URL + 'api/orders-invalid?' + query)
				.then(orders => {
					console.log(orders.data);

					if (orders.data.body) {
					this.orders = orders.data.body;
					this.ordersPreserved = orders.data.body;
					}
					if (orders.data.paging.total) {
					this.totalItems = orders.data.paging.total;
					}
					if (!orders.data.body) {
					console.log("est Vaccio");
					}
				})
				.catch(e => {
					console.log(e);
				})
				.finally(() => {
					this.$vs.loading.close();
				});

			} catch (e) {
				console.log(e);
				this.$vs.loading.close(); 
			}
		},

		handleChangePage (page) {
			this.page = page
			this.loadOrders(page)
		},

		// NEW METHODS FOR ACTIONS
		openDetails(tr) {
		this.orderDetail = tr;
		this.showDetailModal = true;
	},
	handleOrderDetails() {
		this.orderDetail = null;
		this.showDetailModal = false;
		},
	}
}
</script>